import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/home';
import Login from './pages/Login';
import Hospitals from './pages/hospitals';
import Doctors from './pages/doctors';
import KnowledgeCenter from './pages/knowledgecenter';
import CaseStudyDetail from './pages/CaseStudyDetail';
import CaseStudyMain from './pages/CaseStudyMain';
import BlogsMain from './pages/BlogsMain';
import BlogDetail from './pages/BlogDetail';
import TestimonialVideosPage from './pages/TestimonialVideosPage';
import FocussedSpecialities from './pages/FocusedSpeciality';
import SearchResults from './pages/SearchResults';

import DoctorDetails from './pages/DoctorDetails';
import ContactUs from './pages/contactus';
import AirAmbulanceModal from './pages/AirAmbulance';
import IndiaMedicalPage from './pages/IndiaMedicalPage'; 
import TurkeyMedicalPage from './pages/TurkeyMedicalPage'; 
import ThailandMedicalPage from './pages/ThailandMedicalPage'; 
import SouthKoreaMedicalPage from './pages/SouthKoreaMedicalPage';
import HospitalDetail from './pages/HospitalDetail'; 
import Privacy from './pages/privacy';
import About from './pages/about';
import BestHospitalIndia from './pages/besthospitalIndia';
import StarDoctorsIndia from './pages/StarDoctorsIndia';
import StarDoctorsThailand from './pages/StarDoctorsThailand';
import StarDoctorsTurkey from './pages/StarDoctorsTurkey';
import BestHospitalSouthKorea from './pages/besthospitalSouthKorea';
import BestHospitalTurkey from './pages/besthospitalTurkey';
import BestHospitalThailand from './pages/besthospitalThailand';
import BestDoctorsInIndia from './pages/bestdoctorsinindia';
import BestDoctorsInThailand from './pages/bestdoctorsinthailand';
import BestDoctorsInTurkey from './pages/bestdoctorsinturkey';
import BestDoctorsInSouthKorea from './pages/bestdoctorsinsouthkorea';
import TermsAndService from './pages/TermsAndService';

import DonationPage from './pages/DonationPage';
import AllFundraisers from './pages/AllFundraisers';
import FundraiserDetail from './pages/FundraiserDetail';
import BestHospitalDetails from './pages/besthospitaldetails';
import BestDoctorDetails from './pages/BestDoctorDetails';
import TreatmentHome from './pages/TreatmentHome';
import TreatmentsItemPage from './pages/TreatmentsItemPage';


function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/hospitals" element={<Hospitals />} />
          <Route path="/doctors" element={<Doctors />} />

          <Route
            path="/doctor-details/:id"
            element={<DoctorDetails key={window.location.pathname} />}
          />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/AirAmbulance" element={<AirAmbulanceModal />} />
          <Route path="/IndiaMedicalPage" element={<IndiaMedicalPage />} />
          <Route path="/TurkeyMedicalPage" element={<TurkeyMedicalPage />} />
          <Route path="/ThailandMedicalPage" element={<ThailandMedicalPage />} />
          <Route path="/SouthKoreaMedicalPage" element={<SouthKoreaMedicalPage />} />
          <Route path="/hospital/:id" element={<HospitalDetail />} />
          <Route path="/knowledgecenter" element={<KnowledgeCenter />} />
          <Route path="/case-study" element={<CaseStudyMain />} />
          <Route path="/case-study/:slug" element={<CaseStudyDetail />} />
          <Route path="/blogs" element={<BlogsMain />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/testimonial-videos" element={<TestimonialVideosPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/about" element={<About />} />
          <Route path="/BestHospitalIndia" element={<BestHospitalIndia />} />
          <Route path="/BestDoctorsIndia" element={<StarDoctorsIndia />} />
          <Route path="/thailandDoctors" element={<StarDoctorsThailand />} />
          <Route path="/turkeyDoctors" element={<StarDoctorsTurkey />} />
          <Route path="/BestHospitalSouthKorea" element={<BestHospitalSouthKorea />} />
          <Route path="/BestHospitalTurkey" element={<BestHospitalTurkey />} />
          <Route path="/BestHospitalThailand" element={<BestHospitalThailand />} />
          <Route path="/bestdoctorsinindia" element={<BestDoctorsInIndia />} />
          <Route path="/bestdoctorsinthailand" element={<BestDoctorsInThailand />} />
          <Route path="/bestdoctorsinturkey" element={<BestDoctorsInTurkey />} />
          <Route path="/bestdoctorsinsouthkorea" element={<BestDoctorsInSouthKorea />} />
          <Route path="/speciality/:name" element={<FocussedSpecialities />} />
          <Route path="/TermsAndService" element={<TermsAndService />} />

          <Route path="/donation" element={<DonationPage />} />
          <Route path="/all-fundraisers" element={<AllFundraisers />} />
          <Route path="/fundraiser/:id" element={<FundraiserDetail />} />

          <Route path="/besthospitaldetails" element={<BestHospitalDetails />} />
          <Route path="/bestdoctordetails" element={<BestDoctorDetails />} />
          
          <Route path="/treatments" element={<TreatmentHome />} />
          <Route path="/treatments/item" element={<TreatmentsItemPage />} />
          <Route path="/treatments/:slug" element={<TreatmentsItemPage />} />

        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
